import { normalizeTier, type SubscriptionTier } from "@/lib/entitlements";

export type PromoPlanPickProfile = {
  stripe_subscription_id?: string | null;
  owner_promo_trial_ends_at?: string | null;
  owner_promo_granted_tier?: string | null;
  owner_promo_plan_confirmed_at?: string | null;
};

/** User finished promo window and must confirm a paid plan before full access resumes. */
export function needsPostPromoPlanSelection(profile: PromoPlanPickProfile): boolean {
  const hasStripe = Boolean((profile.stripe_subscription_id ?? "").trim());
  if (!hasStripe) return false;
  if (profile.owner_promo_plan_confirmed_at) return false;
  const granted = (profile.owner_promo_granted_tier ?? "").trim().toLowerCase();
  if (granted !== "solo" && granted !== "pro" && granted !== "agency") return false;
  const endRaw = profile.owner_promo_trial_ends_at;
  if (!endRaw) return false;
  const end = new Date(String(endRaw)).getTime();
  return Number.isFinite(end) && end <= Date.now();
}

export function promoGrantedTier(profile: PromoPlanPickProfile): SubscriptionTier | null {
  const t = normalizeTier(profile.owner_promo_granted_tier ?? "");
  if (t === "solo" || t === "pro" || t === "agency") return t;
  return null;
}

export function promoPlanPickBillingHref(plan: SubscriptionTier): string {
  return `/api/billing/change-plan?plan=${plan}&promo_pick=1`;
}
